
import {merge as observableMerge, fromEvent as observableFromEvent, Observable, BehaviorSubject} from 'rxjs';

import {distinctUntilChanged, debounceTime, map} from 'rxjs/operators';
import {Component , ElementRef , OnInit , ViewChild , ViewChildren} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {CantonsService} from '../../../core/services/cantons.service';
import {DataSource} from '@angular/cdk/collections';
import {fuseAnimations} from '../../../core/animations';
import { MatPaginator } from '@angular/material/paginator';
import { MatSidenav } from '@angular/material/sidenav';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';



import {FuseUtils} from '../../../core/fuseUtils';
import {NgxSpinnerService} from 'ngx-spinner';
import {FusePerfectScrollbarDirective} from "../../../core/directives/fuse-perfect-scrollbar/fuse-perfect-scrollbar.directive";
import { UserService } from "../../../core/services/users.service";
import {FuseConfigService} from "../../../core/services/config.service";
import { EventService } from '../../../core/services/event.service';
@Component({
    selector: 'canton-page',
    templateUrl: './canton.component.html',
    styleUrls: ['./canton.component.scss'],
    animations: fuseAnimations,
    standalone: false
})
export class CantonComponent implements OnInit {
  public filterData: any = {};
  cantons: FilesDataSource | null;
  displayedColumns = [ 'name' , 'image' , 'code' , 'country' ];
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild('filter', {static: true}) filter: ElementRef;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild('sidenav') sidenav: MatSidenav;
  @ViewChildren(FusePerfectScrollbarDirective) scroll;

  userFilters;
  defUserFilters;

  constructor (private http: HttpClient , private cantonsService: CantonsService ,
               public snackBar: MatSnackBar, private spinner: NgxSpinnerService,
               public userService: UserService, private fuseConfig: FuseConfigService,
               public eventService: EventService) {
  }

  ngOnInit () {
    this.spinner.show();
    this.cantons = new FilesDataSource(this.cantonsService , this.paginator , this.sort);
    observableFromEvent(this.filter.nativeElement , 'keyup').pipe(
      debounceTime(150),
      distinctUntilChanged(),)
      .subscribe(() => {
        if (!this.cantons) {
          return;
        }
        this.cantons.filter = this.filter.nativeElement.value;
        this.paginator.firstPage();
      });
    this.getCountries();
    this.alertMsg();
    setTimeout(() => {
      this.paginator.firstPage();
      this.spinner.hide();
    } , 500);
    this.paginator.page.subscribe((res) => {
      this.scroll.last.scrollToTop();
    });
    this.getUserFilters();
  }

  getImage(name) {
    return this.eventService.getFileStream(name);
  }

  alertMsg () {

  }

  getCountries () {
    this.cantonsService.getCountry().subscribe((res: any) => {
      if (res.length >= 2) {
        this.filterData.countries = res;
        setTimeout(() => {
          this.sidenav.opened = true;
          this.sidenav.open();
        } , 500);
      } else if (res.length === 1) {
        delete this.filterData.countries;
        setTimeout(() => {
          this.sidenav.close();
          this.sidenav.opened = false;
        } , 1000);
      }
      this.filterData = JSON.parse(JSON.stringify(this.filterData));
    });
  }

  chooseFilters (e) {
    // console.log(e);
    if (e.choose === 'all') {
      delete this.filterData.countries;
      this.cantonsService.setCountryId('');
      this.fetchData();
      this.getCountries();
      this.fuseConfig.setActiveFilter(false);
    } else if (e.choose.hasOwnProperty('country')) {
      this.cantonsService.setCountryId(e.choose.country);
      this.fetchData();
      this.fuseConfig.setActiveFilter(true);
    }
    this.setDataFromFilter(e);
  }

  getUserFilters() {
    this.userService.getFilter('canton').subscribe((res: any) => {
      if (res) {
        this.defUserFilters = res;
        this.userFilters = { canton: JSON.parse(res.config)};
        const config = JSON.parse(res.config);
        if (Object.keys(config).length) {
          this.fuseConfig.setActiveFilter(true);
        } else {
          this.fuseConfig.setActiveFilter(false);
        }
        if (config.hasOwnProperty('country')) {
          this.cantonsService.setCountryId(config.country);
        }
        this.fetchData();

      } else {
        this.fuseConfig.setActiveFilter(false);
        this.userFilters = { canton: {}};
        this.defUserFilters = '';
      }
    });
  }

  setUserFilters(key, value) {
    this.userFilters.canton[key] = value;
    this.userService.setFilters('canton', this.userFilters.canton, this.defUserFilters ? this.defUserFilters.id : '')
      .subscribe((res: any) => {
        this.defUserFilters = res;
      });
  }

  setEmptyUserFilters() {
    this.userService.setFilters('canton', {}, this.defUserFilters ? this.defUserFilters.id : '')
      .subscribe((res: any) => {
        this.defUserFilters = res;
      });
  }

  setDataFromFilter(e) {
    if (e.choose === 'all') {
      this.userFilters.canton = {};
      this.setEmptyUserFilters();
    } else if (e.choose.hasOwnProperty('country')) {
      this.setUserFilters('country', e.choose.country);
    }
  }

  fetchData () {
    this.spinner.show();
    this.cantonsService.getCantons().then(() => {
      setTimeout(() => {
        this.paginator.firstPage();
        this.spinner.hide();
      } , 500);
    });
  }
}

export class FilesDataSource extends DataSource<any> {
  _filterChange = new BehaviorSubject('');
  _filteredDataChange = new BehaviorSubject('');

  get filteredData (): any {
    return this._filteredDataChange.value;
  }

  set filteredData (value: any) {
    this._filteredDataChange.next(value);
  }

  get filter (): string {
    return this._filterChange.value;
  }

  set filter (filter: string) {
    this._filterChange.next(filter);
  }

  constructor (private cantonsService: CantonsService ,
               private _paginator: MatPaginator ,
               private _sort: MatSort) {
    super();
    this.filteredData = this.cantonsService.cantons;
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect (): Observable<any[]> {
    const displayDataChanges = [
      this.cantonsService.onCantonsChanged ,
      this._paginator.page ,
      this._filterChange ,
      this._sort.sortChange
    ];

    return observableMerge(...displayDataChanges).pipe(map(() => {
      let data = this.cantonsService.cantons.slice();

      data = this.filterData(data);

      this.filteredData = [ ...data ];

      data = this.sortData(data);

      // Grab the page's slice of data.
      const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
      return data.splice(startIndex , this._paginator.pageSize);
    }));
  }

  filterData (data) {
    // console.log(data);
    if (!this.filter) {
      return data;
    }
    return FuseUtils.filterArrayByString(data , this.filter);
  }

  sortData (data): any[] {
    if (!this._sort.active || this._sort.direction === '') {
      return data;
    }

    return data.sort((a , b) => {
      let propertyA: number | string = '';
      let propertyB: number | string = '';

      switch (this._sort.active) {
        case 'code':
          [ propertyA , propertyB ] = [ a.code , b.code ];
          break;
        case 'name':
          [ propertyA , propertyB ] = [ a.name , b.name ];
          break;
        case 'country':
          [ propertyA , propertyB ] = [ a.country.name , b.country.name ];
          break;

      }

      const valueA = isNaN(+propertyA) ? propertyA : +propertyA;
      const valueB = isNaN(+propertyB) ? propertyB : +propertyB;

      return (valueA < valueB ? -1 : 1) * (this._sort.direction === 'asc' ? 1 : -1);
    });
  }

  disconnect () {
  }
}
